import IconUserSolid from '@/assets/icons/font_awesome/user-solid.svg?react';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useTranslation } from 'react-i18next';
import { UserAvatarReadOnly } from '../../_base/UserAvatarReadOnly';

export function WSFeaturesTableHeader() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);
  const { all_workspaces_users_map, workspace_current, current_workspace_user } = use_slice_workspace([
    'all_workspaces_users_map',
    'workspace_current',
    'current_workspace_user',
  ]);

  function render_item(item: DTO__workspace_user) {
    return (
      <span key={`ws_features_header_${item._id}`} className={`${md('min-w-[40px] text-[12px]', 'w-[80px] h-[50px]')}  flex items-center justify-center`}>
        <UserAvatarReadOnly url_relative={item.url_relative_avatar} userName={item.full_name} className="!w-5 !h-5" />
      </span>
    );
  }

  function render_header() {
    let users_from_this_workspace = all_workspaces_users_map.get_or_assert(workspace_current._id, { context: 'users_from_this_workspace' });

    let users = Array.from(users_from_this_workspace.values());
    users.sort(DTO__workspace_user.sort_by_name);

    let header_users = Array.from(users_from_this_workspace.values())
      .filter(item => item._id !== current_workspace_user._id)
      .map(render_item);

    return (
      <>
        <span
          className={`${md('min-w-[40px] text-[12px]', 'w-[80px] h-[50px]')} border-r border-dashed border-component-item  flex items-center justify-center`}
        >
          <UI_PRIMITIVE__tooltip delay_duration={0} tooltip_title={t(i18n_page_settings_workspace.tabs.features_access.icon.template_new_user.tooltip)}>
            <UI_PRIMITIVE__icon_animated
              className="!size-4 hover-animation-important text-component-item-foreground hover:text-bar-foreground"
              renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
              Icon={IconUserSolid}
            />
          </UI_PRIMITIVE__tooltip>
        </span>

        {header_users}
      </>
    );
  }

  return render_header();
}
